import axios from "axios";
import {url, jwtDecode} from "../../../crudRequests";
import {fetchRelations} from "./fetchRelations";

export async function addRelation(
  e,
  newRelation,
  state,
  setRelations,
  patient,
  setIsLoading,
  toast
) {
  setIsLoading(true);
  e.preventDefault();
  axios({
    method: "POST",
    url: `${url}/addRelationship`,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + state.jwt,
      "X-Tenant": "patient",
    },
    data: JSON.stringify({
      id: state.jwt ? jwtDecode(state.jwt).id : "",
      addBody: newRelation,
      db: state.db,
      org: state.organization,
      lid: state.selectedLocation,
    }),
  })
    .then((res) => {
      setIsLoading(false);
      toast({
        title: "Relation Added",
        description: "Relation successfully added",
        status: "success",
        isClosable: true,
      });
      fetchRelations(setRelations, state, patient, toast);
    })
    .catch((err) => {
      setIsLoading(false);
      toast({
        title: "Relation Not Added",
        description:
          err?.response?.data || err?.message || "An error occurred.",
        status: "error",
        isClosable: true,
      });
      console.log(err);
    });
}
